'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var CLOSE = exports.CLOSE = 'EXPIRED_SESSION_MODAL:CLOSE';

var ExpiredSessionModalActions = {
	close: function close() {
		return { type: CLOSE };
	}
};

exports.default = ExpiredSessionModalActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/actions/expired-session-modal.js
// module id = 658
// module chunks = 0